"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const test_1 = require("../test");
/**
 * Checks if a variable is divisible by a number.
 *
 * <pre>
 *  {% if loop.index is divisible by(3) %}
 * </pre>
 *
 * @author Fabien Potencier <fabien@symfony.com>
 */
class TwingNodeExpressionTestDivisibleBy extends test_1.TwingNodeExpressionTest {
    compile(compiler) {
        compiler
            .raw('(0 == ')
            .subcompile(this.getNode('node'))
            .raw(' % ')
            .subcompile(this.getNode('arguments').getNode(0))
            .raw(')');
    }
}
exports.TwingNodeExpressionTestDivisibleBy = TwingNodeExpressionTestDivisibleBy;
